/*
  Auto-generated by Spline
*/
import { Canvas } from '@react-three/fiber'
import useSpline from '@splinetool/r3f-spline'
import { PerspectiveCamera, OrbitControls } from '@react-three/drei'

const SkillsScene = ({ ...props }) => {
	const { nodes, materials } = useSpline('https://prod.spline.design/kVCex9ZLrDOBohLX/scene.splinecode')
	return (
		<>
			<Canvas>
				<group {...props} dispose={null}>
					<group
						name="machine learning"
						position={[-229.26, 162.85, -177.93]}
						rotation={[-2.55, -0.78, -2.7]}
						scale={[2, 2, 3]}
					>
						<mesh
							name="m"
							geometry={nodes.m.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-53.45, 0, 0]}
						/>
						<mesh
							name="a"
							geometry={nodes.a.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-29.94, 0, 0]}
						/>
						<mesh
							name="c"
							geometry={nodes.c.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-14.87, 0, 0]}
						/>
						<mesh
							name="h"
							geometry={nodes.h.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-1.22, 0, 0]}
						/>
						<mesh
							name="i"
							geometry={nodes.i.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[13.8, 0, 0]}
						/>
						<mesh
							name="i1"
							geometry={nodes.i1.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[13.8, 0, 0]}
						/>
						<mesh
							name="n"
							geometry={nodes.n.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[20.22, 0, 0]}
						/>
						<mesh
							name="e"
							geometry={nodes.e.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[35.24, 0, 0]}
						/>
						<mesh
							name="l"
							geometry={nodes.l.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-48.22, -24, 0]}
						/>
						<mesh
							name="e1"
							geometry={nodes.e1.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-41.81, -24, 0]}
						/>
						<mesh
							name="a1"
							geometry={nodes.a1.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-28.05, -24, 0]}
						/>
						<mesh
							name="r"
							geometry={nodes.r.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-12.98, -24, 0]}
						/>
						<mesh
							name="n1"
							geometry={nodes.n1.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[-3.31, -24, 0]}
						/>
						<mesh
							name="i2"
							geometry={nodes.i2.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[11.71, -24, 0]}
						/>
						<mesh
							name="i3"
							geometry={nodes.i3.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[11.71, -24, 0]}
						/>
						<mesh
							name="n2"
							geometry={nodes.n2.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[18.13, -24, 0]}
						/>
						<mesh
							name="g"
							geometry={nodes.g.geometry}
							material={materials.glassmaterial}
							castShadow
							position={[33.15, -24, 0]}
						/>
					</group>
					<group name="react" position={[0, 0, 300]} scale={[2, 2, 3]}>
						<mesh name="r1" geometry={nodes.r1.geometry} material={materials.glassmaterial} position={[-30.65, -12, 0]} />
						<mesh name="e2" geometry={nodes.e2.geometry} material={materials.glassmaterial} position={[-20.98, -12, 0]} />
						<mesh name="a2" geometry={nodes.a2.geometry} material={materials.glassmaterial} position={[-7.22, -12, 0]} />
						<mesh name="c1" geometry={nodes.c1.geometry} material={materials.glassmaterial} position={[7.85, -12, 0]} />
						<mesh name="t" geometry={nodes.t.geometry} material={materials.glassmaterial} position={[21.5, -12, 0]} />
					</group>
					<group name="javascript" position={[134.2, -84.41, 292.48]} rotation={[0.26, 0.34, -0.04]} scale={[2, 2, 3]}>
						<mesh name="j" geometry={nodes.j.geometry} material={materials.glassmaterial} position={[-58.46, -12, 0]} />
						<mesh name="a3" geometry={nodes.a3.geometry} material={materials.glassmaterial} position={[-52.02, -12, 0]} />
						<mesh name="v" geometry={nodes.v.geometry} material={materials.glassmaterial} position={[-36.94, -12, 0]} />
						<mesh name="a4" geometry={nodes.a4.geometry} material={materials.glassmaterial} position={[-22.9, -12, 0]} />
						<mesh name="s" geometry={nodes.s.geometry} material={materials.glassmaterial} position={[-7.82, -12, 0]} />
						<mesh name="c2" geometry={nodes.c2.geometry} material={materials.glassmaterial} position={[4.51, -12, 0]} />
						<mesh name="r2" geometry={nodes.r2.geometry} material={materials.glassmaterial} position={[18.16, -12, 0]} />
						<mesh name="i4" geometry={nodes.i4.geometry} material={materials.glassmaterial} position={[27.82, -12, 0]} />
						<mesh name="p" geometry={nodes.p.geometry} material={materials.glassmaterial} position={[34.24, -12, 0]} />
						<mesh name="t1" geometry={nodes.t1.geometry} material={materials.glassmaterial} position={[49.31, -12, 0]} />
					</group>
					<group name="swift" position={[0, 0, -300]} scale={[-2, 2, 3]}>
						<mesh name="S" geometry={nodes.S.geometry} material={materials.glassmaterial} position={[-28.33, -12, 0]} />
						<mesh name="w" geometry={nodes.w.geometry} material={materials.glassmaterial} position={[-14.92, -12, 0]} />
						<mesh name="i5" geometry={nodes.i5.geometry} material={materials.glassmaterial} position={[4.58, -12, 0]} />
						<mesh name="i6" geometry={nodes.i6.geometry} material={materials.glassmaterial} position={[4.58, -12, 0]} />
						<mesh name="f" geometry={nodes.f.geometry} material={materials.glassmaterial} position={[11, -12, 0]} />
						<mesh name="t2" geometry={nodes.t2.geometry} material={materials.glassmaterial} position={[19.18, -12, 0]} />
					</group>
					<group name="java" position={[300, 0, 0]} rotation={[0, Math.PI / 2, 0]} scale={[2, 2, 3]}>
						<mesh name="j1" geometry={nodes.j1.geometry} material={materials.glassmaterial} position={[-25.32, -12, 0]} />
						<mesh name="j2" geometry={nodes.j2.geometry} material={materials.glassmaterial} position={[-25.32, -12, 0]} />
						<mesh name="a5" geometry={nodes.a5.geometry} material={materials.glassmaterial} position={[-18.87, -12, 0]} />
						<mesh name="v1" geometry={nodes.v1.geometry} material={materials.glassmaterial} position={[-3.8, -12, 0]} />
						<mesh name="a6" geometry={nodes.a6.geometry} material={materials.glassmaterial} position={[10.25, -12, 0]} />
					</group>
					<group name="python" position={[0, 172.47, 300]} rotation={[-Math.PI / 6, 0, 0]} scale={[2, 2, 3]}>
						<mesh name="p1" geometry={nodes.p1.geometry} material={materials.glassmaterial} position={[-41.29, -12, 0]} />
						<mesh name="y" geometry={nodes.y.geometry} material={materials.glassmaterial} position={[-26.22, -12, 0]} />
						<mesh name="t3" geometry={nodes.t3.geometry} material={materials.glassmaterial} position={[-12.12, -12, 0]} />
						<mesh name="h1" geometry={nodes.h1.geometry} material={materials.glassmaterial} position={[-2.97, -12, 0]} />
						<mesh name="o" geometry={nodes.o.geometry} material={materials.glassmaterial} position={[12.06, -12, 0]} />
						<mesh name="n3" geometry={nodes.n3.geometry} material={materials.glassmaterial} position={[26.26, -12, 0]} />
					</group>
					<group name="GCP" position={[191.32, 1, 303.87]} rotation={[0, 0.6, 0]} scale={[2, 2, 3]}>
						<mesh name="G" geometry={nodes.G.geometry} material={materials.glassmaterial} position={[-23.75, -12, 0]} />
						<mesh name="C" geometry={nodes.C.geometry} material={materials.glassmaterial} position={[-6.82, -12, 0]} />
						<mesh name="P" geometry={nodes.P.geometry} material={materials.glassmaterial} position={[9.99, -12, 0]} />
					</group>
					<group name="Node" position={[-181.63, 1, 276.24]} rotation={[0, -0.56, 0]} scale={[2, 2, 3]}>
						<mesh name="N" geometry={nodes.N.geometry} material={materials.glassmaterial} position={[-29.81, -12, 0]} />
						<mesh name="o1" geometry={nodes.o1.geometry} material={materials.glassmaterial} position={[-13.23, -12, 0]} />
						<mesh name="d" geometry={nodes.d.geometry} material={materials.glassmaterial} position={[0.98, -12, 0]} />
						<mesh name="e3" geometry={nodes.e3.geometry} material={materials.glassmaterial} position={[16.05, -12, 0]} />
					</group>
					<group name="Flask" position={[-318.68, 1, -13.18]} rotation={[Math.PI, -1.53, Math.PI]} scale={[2, 2, 3]}>
						<mesh name="F" geometry={nodes.F.geometry} material={materials.glassmaterial} position={[-29.75, 0, 0]} />
						<mesh name="l1" geometry={nodes.l1.geometry} material={materials.glassmaterial} position={[-17.54, 0, 0]} />
						<mesh name="a7" geometry={nodes.a7.geometry} material={materials.glassmaterial} position={[-11.13, 0, 0]} />
						<mesh name="s1" geometry={nodes.s1.geometry} material={materials.glassmaterial} position={[3.94, 0, 0]} />
						<mesh name="k" geometry={nodes.k.geometry} material={materials.glassmaterial} position={[16.28, 0, 0]} />
					</group>
					<group name="APIs" position={[306.24, 47.34, 145.22]} rotation={[0, 1.15, 0]} scale={[2, 2, 3]}>
						<mesh name="A" geometry={nodes.A.geometry} material={materials.glassmaterial} position={[-24.37, -12, 0]} />
						<mesh name="P1" geometry={nodes.P1.geometry} material={materials.glassmaterial} position={[-8.14, -12, 0]} />
						<mesh name="I" geometry={nodes.I.geometry} material={materials.glassmaterial} position={[5.62, -12, 0]} />
						<mesh name="s2" geometry={nodes.s2.geometry} material={materials.glassmaterial} position={[12.03, -12, 0]} />
					</group>
					<group name="Next.js" position={[259.85, 96.9, -187.01]} rotation={[-2.54, 0.92, 2.64]} scale={[2, 2, 3]}>
						<mesh name="N1" geometry={nodes.N1.geometry} material={materials.glassmaterial} position={[-36.2, 0, 0]} />
						<mesh name="e4" geometry={nodes.e4.geometry} material={materials.glassmaterial} position={[-19.24, 0, 0]} />
						<mesh name="x" geometry={nodes.x.geometry} material={materials.glassmaterial} position={[-5.91, 0, 0]} />
						<mesh name="t4" geometry={nodes.t4.geometry} material={materials.glassmaterial} position={[5.82, 0, 0]} />
						<mesh name="." geometry={nodes['.'].geometry} material={materials.glassmaterial} position={[14.31, 0, 0]} />
						<mesh name="j3" geometry={nodes.j3.geometry} material={materials.glassmaterial} position={[19.29, 0, 0]} />
						<mesh name="s3" geometry={nodes.s3.geometry} material={materials.glassmaterial} position={[24.9, 0, 0]} />
					</group>
					<group name="AWS" position={[-9.59, 121.87, -296.2]} rotation={[-2.79, -0.02, -3.14]} scale={[2, 2, 3]}>
						<mesh name="A1" geometry={nodes.A1.geometry} material={materials.glassmaterial} position={[-26.04, -12, 0]} />
						<mesh name="W" geometry={nodes.W.geometry} material={materials.glassmaterial} position={[-11.03, -12, 0]} />
						<mesh name="S1" geometry={nodes.S1.geometry} material={materials.glassmaterial} position={[12.38, -12, 0]} />
					</group>
					<group name="SSR" position={[-260.06, -108.27, -156.86]} rotation={[2.45, -0.89, 2.52]} scale={[2, 2, 3]}>
						<mesh name="S2" geometry={nodes.S2.geometry} material={materials.glassmaterial} position={[-20.47, -12, 0]} />
						<mesh name="S3" geometry={nodes.S3.geometry} material={materials.glassmaterial} position={[-7.06, -12, 0]} />
						<mesh name="R" geometry={nodes.R.geometry} material={materials.glassmaterial} position={[6.34, -12, 0]} />
					</group>
					<group name="SPAs" position={[-197.85, 1, -271.26]} rotation={[0, -2.56, 0]} scale={[2, 2, 3]}>
						<mesh name="S4" geometry={nodes.S4.geometry} material={materials.glassmaterial} position={[-27.86, -12, 0]} />
						<mesh name="P2" geometry={nodes.P2.geometry} material={materials.glassmaterial} position={[-14.46, -12, 0]} />
						<mesh name="A2" geometry={nodes.A2.geometry} material={materials.glassmaterial} position={[-0.7, -12, 0]} />
						<mesh name="s4" geometry={nodes.s4.geometry} material={materials.glassmaterial} position={[15.53, -12, 0]} />
					</group>
					<group name="Linux" position={[-301.14, 127.21, 60.69]} rotation={[-1.04, -1.24, -1.03]} scale={[2, 2, 3]}>
						<mesh name="L" geometry={nodes.L.geometry} material={materials.glassmaterial} position={[-30.23, -12, 0]} />
						<mesh name="i7" geometry={nodes.i7.geometry} material={materials.glassmaterial} position={[-19.61, -12, 0]} />
						<mesh name="i8" geometry={nodes.i8.geometry} material={materials.glassmaterial} position={[-19.61, -12, 0]} />
						<mesh name="n4" geometry={nodes.n4.geometry} material={materials.glassmaterial} position={[-13.19, -12, 0]} />
						<mesh name="u" geometry={nodes.u.geometry} material={materials.glassmaterial} position={[1.83, -12, 0]} />
						<mesh name="x1" geometry={nodes.x1.geometry} material={materials.glassmaterial} position={[16.79, -12, 0]} />
					</group>
					<group name="SQL" position={[-245.48, 121.19, 244.26]} rotation={[-0.5, -0.78, -0.36]} scale={[2, 2, 3]}>
						<mesh name="S5" geometry={nodes.S5.geometry} material={materials.glassmaterial} position={[-20.78, -12, 0]} />
						<mesh name="Q" geometry={nodes.Q.geometry} material={materials.glassmaterial} position={[-7.38, -12, 0]} />
						<mesh name="L1" geometry={nodes.L1.geometry} material={materials.glassmaterial} position={[10.16, -12, 0]} />
					</group>
					<group name="sklearn" position={[293.41, 72.35, 117.52]} rotation={[-0.49, 1.1, 0.39]} scale={[2, 2, 3]}>
						<mesh name="s5" geometry={nodes.s5.geometry} material={materials.glassmaterial} position={[-50, 26, 0]} />
						<mesh name="k1" geometry={nodes.k1.geometry} material={materials.glassmaterial} position={[-37.66, 26, 0]} />
						<mesh name="l2" geometry={nodes.l2.geometry} material={materials.glassmaterial} position={[-24.19, 26, 0]} />
						<mesh name="e5" geometry={nodes.e5.geometry} material={materials.glassmaterial} position={[-17.78, 26, 0]} />
						<mesh name="a8" geometry={nodes.a8.geometry} material={materials.glassmaterial} position={[-4.02, 26, 0]} />
						<mesh name="r3" geometry={nodes.r3.geometry} material={materials.glassmaterial} position={[11.06, 26, 0]} />
						<mesh name="n5" geometry={nodes.n5.geometry} material={materials.glassmaterial} position={[20.72, 26, 0]} />
					</group>
					<group name="NLTK" position={[176.55, -22.47, -267.91]} rotation={[3.02, 0.66, -3.07]} scale={[2, 2, 3]}>
						<mesh name="N2" geometry={nodes.N2.geometry} material={materials.glassmaterial} position={[-27.71, -12, 0]} />
						<mesh name="L2" geometry={nodes.L2.geometry} material={materials.glassmaterial} position={[-11.14, -12, 0]} />
						<mesh name="T" geometry={nodes.T.geometry} material={materials.glassmaterial} position={[-0.51, -12, 0]} />
						<mesh name="K" geometry={nodes.K.geometry} material={materials.glassmaterial} position={[12.38, -12, 0]} />
					</group>
					<group name="CSS" position={[146.9, 134.2, 253.92]} rotation={[-0.45, 0.5, 0.28]} scale={[2, 2, 3]}>
						<mesh name="c3" geometry={nodes.c3.geometry} material={materials.glassmaterial} position={[-19.16, -12, 0]} />
						<mesh name="s6" geometry={nodes.s6.geometry} material={materials.glassmaterial} position={[-5.51, -12, 0]} />
						<mesh name="s7" geometry={nodes.s7.geometry} material={materials.glassmaterial} position={[6.82, -12, 0]} />
					</group>
					<group name="html" position={[203.15, 228.05, 187.53]} rotation={[-0.8, 0.63, 0.45]} scale={[2, 2, 3]}>
						<mesh name="h2" geometry={nodes.h2.geometry} material={materials.glassmaterial} position={[-27.05, -12, 0]} />
						<mesh name="t5" geometry={nodes.t5.geometry} material={materials.glassmaterial} position={[-12.02, -12, 0]} />
						<mesh name="m1" geometry={nodes.m1.geometry} material={materials.glassmaterial} position={[-2.87, -12, 0]} />
						<mesh name="l3" geometry={nodes.l3.geometry} material={materials.glassmaterial} position={[20.63, -12, 0]} />
					</group>
					<mesh
						name="Sphere"
						geometry={nodes.Sphere.geometry}
						material={nodes.Sphere.material}
						castShadow
						receiveShadow
						scale={6}
					/>
					<PerspectiveCamera
						name="1"
						makeDefault={true}
						far={100000}
						near={5}
						fov={45}
						position={[736.88, 124.54, 1136.71]}
						rotation={[-0.11, 0.57, 0.06]}
					/>
					<hemisphereLight name="Default Ambient Light" intensity={1} position={[0, 1, 0]} />
				</group>
				<OrbitControls autoRotate />
			</Canvas>
		</>
	)
}

export default SkillsScene